import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const adminTokenKey = "talentbridge_admin_token";

export const getAdminToken = () => localStorage.getItem(adminTokenKey);

export const setAdminToken = (token) => localStorage.setItem(adminTokenKey, token);

export const clearAdminToken = () => localStorage.removeItem(adminTokenKey);

const authHeaders = () => ({ Authorization: `Bearer ${getAdminToken()}` });

export const api = {
  employerLead: (payload) => axios.post(`${API_BASE}/employer-leads`, payload),
  candidate: (payload) => axios.post(`${API_BASE}/candidates`, payload),
  contact: (payload) => axios.post(`${API_BASE}/contact-messages`, payload),
  booking: (payload) => axios.post(`${API_BASE}/bookings`, payload),
  jobPost: (payload) => axios.post(`${API_BASE}/job-posts`, payload),
  jobApplication: (payload) => axios.post(`${API_BASE}/job-applications`, payload),
  publicJobs: (params = {}) => axios.get(`${API_BASE}/jobs`, { params }),
  jobAlert: (payload) => axios.post(`${API_BASE}/job-alerts`, payload),
  trackVisitor: (payload) => axios.post(`${API_BASE}/visitors/track`, payload),
  parseResume: (formData) => axios.post(`${API_BASE}/resume/parse`, formData, { headers: { "Content-Type": "multipart/form-data" } }),
  checkResume: (payload) => axios.post(`${API_BASE}/resume/check`, payload),
  improveResume: (payload) => axios.post(`${API_BASE}/resume/improve`, payload),
  tailorResume: (payload) => axios.post(`${API_BASE}/resume/tailor`, payload),
  adminLogin: (payload) => axios.post(`${API_BASE}/admin/login`, payload),
  overview: () => axios.get(`${API_BASE}/admin/overview`, { headers: authHeaders() }),
  contactMessages: () => axios.get(`${API_BASE}/admin/contact-messages`, { headers: authHeaders() }),
  updateContactMessageStatus: (id, status) => axios.patch(`${API_BASE}/admin/contact-messages/${id}/status`, { status }, { headers: authHeaders() }),
  jobPosts: () => axios.get(`${API_BASE}/admin/job-posts`, { headers: authHeaders() }),
  updateJobPostStatus: (id, status) => axios.patch(`${API_BASE}/admin/job-posts/${id}/status`, { status }, { headers: authHeaders() }),
  jobApplications: () => axios.get(`${API_BASE}/admin/job-applications`, { headers: authHeaders() }),
  updateJobApplicationStatus: (id, status) => axios.patch(`${API_BASE}/admin/job-applications/${id}/status`, { status }, { headers: authHeaders() }),
  jobAlerts: () => axios.get(`${API_BASE}/admin/job-alerts`, { headers: authHeaders() }),
  visitors: () => axios.get(`${API_BASE}/admin/visitors`, { headers: authHeaders() }),
  resumeUsage: () => axios.get(`${API_BASE}/admin/resume-usage`, { headers: authHeaders() }),
  savedResumes: () => axios.get(`${API_BASE}/admin/saved-resumes`, { headers: authHeaders() }),
  updateSavedResumeStatus: (id, status) => axios.patch(`${API_BASE}/admin/saved-resumes/${id}/status`, { status }, { headers: authHeaders() }),
  pipeline: () => axios.get(`${API_BASE}/admin/pipeline`, { headers: authHeaders() }),
  templates: () => axios.get(`${API_BASE}/admin/email-templates`, { headers: authHeaders() }),
  updateStage: (type, id, stage) =>
    axios.patch(`${API_BASE}/admin/pipeline/${type}/${id}/stage`, { stage }, { headers: authHeaders() }),
  coldEmailOverview: () => axios.get(`${API_BASE}/admin/cold-email/overview`, { headers: authHeaders() }),
  prospects: () => axios.get(`${API_BASE}/admin/cold-email/prospects`, { headers: authHeaders() }),
  createProspect: (payload) => axios.post(`${API_BASE}/admin/cold-email/prospects`, payload, { headers: authHeaders() }),
  campaigns: () => axios.get(`${API_BASE}/admin/cold-email/campaigns`, { headers: authHeaders() }),
  createCampaign: (payload) => axios.post(`${API_BASE}/admin/cold-email/campaigns`, payload, { headers: authHeaders() }),
  generateColdEmail: (payload) => axios.post(`${API_BASE}/admin/cold-email/generate`, payload, { headers: authHeaders() }),
  coldEmailDrafts: () => axios.get(`${API_BASE}/admin/cold-email/drafts`, { headers: authHeaders() }),
  queueEmail: (payload) => axios.post(`${API_BASE}/admin/cold-email/queue`, payload, { headers: authHeaders() }),
  emailQueue: () => axios.get(`${API_BASE}/admin/cold-email/queue`, { headers: authHeaders() }),
  emailProviderStatus: () => axios.get(`${API_BASE}/admin/cold-email/provider-status`, { headers: authHeaders() }),
  sendQueuedEmail: (id) => axios.post(`${API_BASE}/admin/cold-email/queue/${id}/send`, {}, { headers: authHeaders() }),
  updateQueueStatus: (id, status) => axios.patch(`${API_BASE}/admin/cold-email/queue/${id}/status`, { status }, { headers: authHeaders() }),
  optOuts: () => axios.get(`${API_BASE}/admin/cold-email/opt-outs`, { headers: authHeaders() }),
  createOptOut: (payload) => axios.post(`${API_BASE}/admin/cold-email/opt-outs`, payload, { headers: authHeaders() }),
};